const Section_Divider = () => (
  <div className="h-20 mx-auto my-16 border-l-2 border-solid" />
)

export default Section_Divider
